<ng-content select="[lyceoIconPrefix]" />
<ng-content />
<ng-content select="[lyceoIconSuffix]" />
